import React from 'react'

import Section from '../Section'

import relationIcon from 'assets/images/contacts/Editor/editor-relation-20.svg'

import { useTranslation } from 'react-i18next'

interface RelationsProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const Relations = ({
  editData,
  onFieldChange,
  onLabelChange,
  onAddItem,
  onDelete,
}: RelationsProps) => {
  const { t } = useTranslation()
  return (
    <Section
      editData={editData}
      propName="related_persons"
      labelList={[
        { key: 'spouse', label: t('contact.property.spouse') },
        { key: 'child', label: t('contact.property.child') },
        { key: 'mother', label: t('contact.property.mother') },
        { key: 'father', label: t('contact.property.father') },
        { key: 'parent', label: t('contact.property.parent') },
        { key: 'brother', label: t('contact.detail.brother') },
        { key: 'sister', label: t('contact.property.sister') },
        { key: 'friend', label: t('contact.property.friend') },
        { key: 'relative', label: t('contact.property.relative') },
        { key: 'manager', label: t('contact.property.manager') },
        { key: 'assistant', label: t('contact.property.assistant') },
        { key: 'referredby', label: t('contact.property.referredby') },
        { key: 'partner', label: t('contact.property.partner') },
        { key: 'domesticpartner', label: t('contact.property.domesticpartner') },
        { key: '', label: t('contact.property.none') },
        { key: 'custom', label: t('contact.property.custom') },
      ]}
      icon={relationIcon}
      addButtonLabel={t('contact.menu.addRelation')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(_) => true}
    />
  )
}
export default Relations
